import * as React from "react";

import { DialogContent } from "../../ui/dialog";
import { cn } from "../../utils/common/cn";

/**
 * DialogContent for the Portfolio Risk Concentration pop-ups. The frame keeps a gap above and below the window (at most 85% of its
 * height, like Define a joint), the body scrolls inside it, and a strip of padding under the scroll area stays visible, so the content
 * is never cut flush at the bottom edge. The close button belongs to the frame, so it stays put while the body scrolls.
 *
 * Use it exactly like DialogContent: the children are laid out as before (a grid, gap-4, 1.5rem side padding).
 */
export const PrcDialogContent = React.forwardRef<
  React.ElementRef<typeof DialogContent>,
  React.ComponentPropsWithoutRef<typeof DialogContent>
>(({ className, children, ...props }, ref) => (
  <DialogContent ref={ref} className={cn("flex max-h-[85vh] flex-col gap-0 overflow-hidden p-0 pb-6", className)} {...props}>
    <div className="grid min-h-0 flex-1 gap-4 overflow-y-auto px-6 pt-6">{children}</div>
  </DialogContent>
));
PrcDialogContent.displayName = "PrcDialogContent";
